export function CancelButton({ setIsEditing, setCurrentText, oldText }: { setIsEditing: (isEditing: boolean) => void; setCurrentText: (text: string) => void; oldText: React.MutableRefObject<string>; }) {
    const handleClick = () => {
        setIsEditing(false);
        setCurrentText(oldText.current);
    };
    return (
        <button onClick={handleClick} className="bg-red-500 text-white p-2 rounded-md">Cancel</button>
    );
}
